import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4a1 1 0 0 1 1 1v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1 -2 0v-6h-6a1 1 0 0 1 0 -2h6v-6a1 1 0 0 1 1 -1","key":"svg-0"}]]

/**
 * IconPlusFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItcGx1cyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgNGExIDEgMCAwIDEgMSAxdjZoNmExIDEgMCAwIDEgMCAyaC02djZhMSAxIDAgMCAxIC0yIDB2LTZoLTZhMSAxIDAgMCAxIDAgLTJoNnYtNmExIDEgMCAwIDEgMSAtMSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/plus-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlusFilled = createReactComponent('filled', 'plus-filled', 'PlusFilled', __iconNode);

export default IconPlusFilled;